<template>
    <modal
        name="group"
        height="auto"
        class="pt-5 pb-5"
        :scrollable="true"
        width="60%"
    >
        <div class="p-4 d-flex justify-content-between h-100 flex-column">
            <div>
                <div class="form-group">
                    <label for="name">Name</label>
                    <input
                        id="name"
                        v-model="group.name"
                        type="text"
                        class="form-control"
                    >
                </div>
            </div>
            <div class="d-flex">
                <button
                    class="btn btn-secondary mr-3"
                    @click="$modal.hide('group')"
                >
                    <span>Cancel</span>
                </button>

                <button
                    class="btn btn-primary"
                    @click="$emit('save')"
                >
                    <span>Save</span>
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: 'GroupModal',

    props: {
        group: {
            type: Object,
            required: true,
        },
    },
};
</script>
